type ENV = "dev" | "qa" | "sit" | "uat" | "stage" | "support" | "prod"

// const env: ENV = ( process.env.NEXT_PUBLIC_ENV ?
//   process.env.NEXT_PUBLIC_ENV?.toLowerCase() === "staging"
//     ? "stage"
//     : process.env.NEXT_PUBLIC_ENV?.toLowerCase() === "production"
//       ? "prod"
//       : process.env.NEXT_PUBLIC_ENV?.toLowerCase() === "hotfix"
//         ? "support"
//         : process.env.NEXT_PUBLIC_ENV?.toLowerCase()
//     : "stage"
//   ) as ENV

function normalizeEnv(rawEnv: string | undefined): ENV {
  const value = rawEnv?.toLowerCase()
  if (!value) {
    return "stage"
  }
  if (value === "staging") {
    return "stage"
  }
  if (value === "production") {
    return "prod"
  }
  if (value === "hotfix") {
    return "support"
  }
  const allowedEnvs: ENV[] = [
    "dev",
    "qa",
    "sit",
    "uat",
    "stage",
    "support",
    "prod",
  ]
  if (allowedEnvs.includes(value as ENV)) {
    return value as ENV
  }
  // Fallback to a safe default if the value is not recognized
  return "stage"
}
const env: ENV = normalizeEnv(process.env.NEXT_PUBLIC_ENV)

const tidEnvMap: Record<ENV, string> = {
  dev: "https://stage.id.trimblecloud.com",
  qa: "https://stage.id.trimblecloud.com",
  sit: "https://sit.id.trimblecloud.com",
  uat: "https://uat.id.trimblecloud.com",
  stage: "https://stage.id.trimblecloud.com",
  support: "https://stage.id.trimblecloud.com",
  prod: "https://id.trimble.com",
}

const tidProfileBaseMap: Record<ENV, string> = {
  dev: "https://cloud.stage.api.trimblecloud.com/platform/iam/1.0",
  qa: "https://cloud.stage.api.trimblecloud.com/platform/iam/1.0",
  sit: "https://cloud.sit.api.trimblecloud.com/platform/iam/v1",
  uat: "https://cloud.uat.api.trimblecloud.com/platform/iam/v1",
  stage: "https://cloud.stage.api.trimblecloud.com/platform/iam/1.0",
  support: "https://cloud.stage.api.trimblecloud.com/platform/iam/1.0",
  prod: "https://cloud.api.trimble.com/platform/iam/1.0",
}

const envMyProfileMap: Record<ENV, string> = {
  dev: "https://stage.myprofile.trimblecloud.com",
  qa: "https://stage.myprofile.trimblecloud.com",
  sit: "https://sit.myprofile.trimblecloud.com",
  uat: "https://uat.myprofile.trimblecloud.com",
  stage: "https://stage.myprofile.trimblecloud.com",
  support: "https://stage.myprofile.trimblecloud.com",
  prod: "https://myprofile.trimble.com",
}

const ecomProductsLinkMap: Record<ENV, string> = {
  dev: "https://dev.accounts.trimble.com/products",
  qa: "https://qa.accounts.trimble.com/products",
  sit: "https://sit.accounts.trimble.com/products",
  uat: "https://uat.accounts.trimble.com/products",
  stage: "https://stage.accounts.trimble.com/products",
  support: "https://support.accounts.trimble.com/products",
  prod: "https://accounts.trimble.com/products",
}

const _ecomSupportLinkMap: Record<ENV, string> = {
  dev: "https://r4dev.my.trimblecloud.com/s/contactsupport",
  qa: "https://r4qa.my.trimblecloud.com/s/contactsupport",
  sit: "https://r4sit.my.trimblecloud.com/s/contactsupport",
  uat: "https://r4uat.my.trimblecloud.com/s/contactsupport",
  stage: "https://r4stage.my.trimblecloud.com/s/contactsupport",
  support: "https://r4stage.my.trimblecloud.com/s/contactsupport",
  prod: "https://my.trimble.com/s/contactsupport",
}

const tidBaseUrl = tidEnvMap[env]
const tidClientId = process.env.NEXT_PUBLIC_TID_CLIENT_ID //tidClientCodeMap[env]
const tidClientSecret = process.env.NEXT_PUBLIC_TID_CLIENT_SECRET //tidClientSecretMap[env]
const tidProfilesBaseUrl: string =
  process.env.NEXT_PUBLIC_PROFILES_BASE_URL || tidProfileBaseMap[env]

const checkoutBaseUrl: string =
  process.env.NEXT_PUBLIC_CHECKOUT_BASE_URL ||
  (env === "prod"
    ? "https://shop.trimble.com"
    : `https://${env}.shop.trimble.com`)
const productsEndpoint: string =
  process.env.NEXT_PUBLIC_PRODUCTS_ENDPOINT ||
  (env === "prod"
    ? "https://shop.trimble.com/api/products-service/v1"
    : `https://${env}.shop.trimble.com/api/products-service/v1`)
const accountsEndpoint: string =
  process.env.NEXT_PUBLIC_ACCOUNTS_ENDPOINT ||
  (env === "prod"
    ? "https://shop.trimble.com/api/accounts-service/v1"
    : `https://${env}.shop.trimble.com/api/accounts-service/v1`)

const myProfileBaseUrl: string =
  process.env.NEXT_PUBLIC_MYPROFILE_BASE_URL || envMyProfileMap[env]
const productsLink: string =
  process.env.NEXT_PUBLIC_PRODUCTS_LINK || ecomProductsLinkMap[env]
const accountsBaseUrl: string =
  process.env.NEXT_PUBLIC_ACCOUNT_BASE_URL_FLYOUT_LINK ||
  (env === "prod"
    ? "https://accounts.trimble.com"
    : `https://${env}.accounts.trimble.com`)

// Trimble Assist only ships two backends, so every non-production MXP
// environment points at the staging one.
const assistEnvironment: "stage" | "prod" = env === "prod" ? "prod" : "stage"
const assistAgentId: string | undefined =
  process.env.NEXT_PUBLIC_ASSIST_AGENT_ID

// Anonymous Algolia chat (trimble-terra/AnonymousChat). The FAB only mounts
// when an origin is configured for the deployment -- there is deliberately
// no fallback so a prod build can never talk to dev.frontdoor.
// Literal process.env.NEXT_PUBLIC_* reads so Next.js inlines them client-side.
const chatApiOrigin: string | undefined =
  process.env.NEXT_PUBLIC_CHAT_API_ORIGIN || undefined

export {
  env,
  tidBaseUrl,
  tidClientId,
  tidClientSecret,
  tidProfilesBaseUrl,
  checkoutBaseUrl,
  productsEndpoint,
  accountsEndpoint,
  myProfileBaseUrl,
  productsLink,
  accountsBaseUrl,
  assistEnvironment,
  assistAgentId,
  chatApiOrigin,
}

